(function()
{
	//Import classes
	var BasePanel = include('springroll.easeljs.BasePanel'),
		Text = include('createjs.Text'),
		Delay = include('springroll.DelayedCall'),
		Container = include('createjs.Container');

	/**
	 * Panel contains all of the visual elements for the Game state
	 * @class Lemonade.KitchenPanel
	 * @extends springroll.easeljs.BasePanel
	 */
	var KitchenPanel = function()
	{
		BasePanel.call(this);

		this.playIntroSequence = this.playIntroSequence.bind(this);

	};

	//Super prototype
	var s = BasePanel.prototype;

	//Extend the base panel
	var p = extend(KitchenPanel, BasePanel);

	/**
	 * Setup the state, this happens on each state entering
	 */
	p.setup = function()
	{
		this.state = app.states.kitchen;

		this.sceneLib = app.globalState.language == "en" ? lib_kitchen : lib_kitchen_es;
		this.skin = new this.sceneLib[app.globalState.language == "en" ? "Kitchen" : "Kitchen_sp"]();
		this.skin._updateTimeline();
		this.addChild(this.skin);

		this.kitchen = this.skin.kitchen;

		this.ingredients = this.kitchen.ingredients;
		this.ingredients.framerate = 31;
		this.ingredients.stop();

		this.pitcher = this.ingredients.pitcher;
		this.pitcher.framerate = 31;
		this.pitcher.stop();

		this.lemons = [
			this.ingredients.lemon1,
			this.ingredients.lemon2,
			this.ingredients.lemon3
		];
		this.water = [
			this.ingredients.water1,
			this.ingredients.water2,
			this.ingredients.water3,
			this.ingredients.water4
		];
		this.sugar = this.ingredients.sugar;
		this.spoon = this.ingredients.spoon;

		// setup counter
		this.counter = new lib_outside.counter();
		this.counter.stop();
		this.counter.visible = false;
		this.addChild(this.counter);

		// Setup characters
		this.grover = this.kitchen.grover;
		this.grover.framerate = 31;
		this.grover.stop();

		this.elmo = this.kitchen.elmo;
		this.elmo.framerate = 31;
		this.elmo.stop();

		// Animation sequence settings
		this.activeChar = this.grover;
		this.sequenceStage = -1;
		this.introSequence = [
			{
				char: "Elmo",
				anim: "Kitchen_1"
			},
			{
				char: "Grover",
				anim: "Kitchen_2"
			}
		];

		this.gtmTimeoutStart = -1;
	};

	p.playIntroSequence = function() {
		this.sequenceStage++;
		if (this.sequenceStage >= this.introSequence.length) {
			this.onIntroComplete();
			return;
		}

		var nextAnim = this.introSequence[this.sequenceStage];
		if (nextAnim.char == "Grover") {
			this.activeChar = this.grover;
			app.animator.play(this.elmo, "idle");
		} else {
			this.activeChar = this.elmo;
		}

		app.animator.play(
			this.activeChar,
			this.config.animations[nextAnim.char][nextAnim.anim],
			this.playIntroSequence
		);
	};

	p.onIntroComplete = function() {
		createjs.Tween.get(this.kitchen)
			.to({scaleX: 2.15, scaleY: 2.15, y: 260, x: 610}, 500)
			.call(this.state.onIntroComplete);

		// createjs.Tween.get(this.ingredients)
		// 	.to({x: 550}, 500);

		createjs.Tween.get(this.kitchen.children[0])
			.to({scaleX: 0.7, scaleY: 0.7, x: 198, y: 117}, 500);

		createjs.Tween.get(this.grover)
			.to({x: 1320}, 500)
			.call(function(){
				this.grover.visible = false;
			}.bind(this));

		createjs.Tween.get(this.elmo)
			.to({x: 0}, 500)
			.call(function(){
				this.elmo.visible = false;
			}.bind(this));
	};


	/**
	 * Un-setup the panel when exiting the state
	 */
	p.teardown = function()
	{
		s.teardown.call(this);
		this.skin = null;
	};

	//Assign to namespace
	namespace('Lemonade').KitchenPanel = KitchenPanel;
})(lib = lib||{}, images = images||{}, createjs = createjs||{}, ss = ss||{});
var lib, images, createjs, ss;